const DISMISS_EXPIRY_DAYS = 7;
const DAY_MS = 1000 * 60 * 60 * 24;

interface DismissHelpers {
  isDismissed(id: string): boolean;
  dismiss(id: string): void;
}

export function createDismissHelpers(prefix: string): DismissHelpers {
  const key = (id: string) => `${prefix}${id}_dismissed_at`;

  return {
    isDismissed(id: string): boolean {
      if (typeof window === 'undefined') return false;
      const raw = localStorage.getItem(key(id));
      if (!raw) return false;
      const days = (Date.now() - new Date(raw).getTime()) / DAY_MS;
      if (days >= DISMISS_EXPIRY_DAYS) {
        localStorage.removeItem(key(id));
        return false;
      }
      return true;
    },
    dismiss(id: string): void {
      if (typeof window === 'undefined') return;
      localStorage.setItem(key(id), new Date().toISOString());
    },
  };
}
